export class CompanyOwnerNameRawDto {
  companyName: string;
  contactName: string;
}
